import React from 'react';
import { TrendingUp } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function CreditBuilderPage() {
  const module = getModule('credit-builder')!;
  return (
    <ModulePageLayout module={module} Icon={TrendingUp}>
      <Section title="Build Credit With Real Bureau Reporting">
        <p className="text-gray-700 leading-relaxed">
          Credit Builder helps you establish or improve your credit score by reporting positive payment
          behavior directly to Equifax, TransUnion, and Experian. Every repayment is tracked for bureau
          compliance and powers eligibility for other platform features.
        </p>
      </Section>

      <Section title="Three Ways to Start">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Dedicated</h3>
            <p className="text-gray-600 text-sm">No deposit required. A small starter limit designed for first-time credit builders.</p>
          </div>
          <div className="border-2 border-emerald-500 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Secured</h3>
            <p className="text-gray-600 text-sm">Your credit limit equals your security deposit — lower risk for the platform, lower interest for you.</p>
          </div>
          <div className="border border-gray-200 rounded-xl p-5">
            <h3 className="font-bold text-gray-900 mb-2">Unsecured</h3>
            <p className="text-gray-600 text-sm">No deposit, higher limit — based on your history and score. Requires qualification.</p>
          </div>
        </div>
      </Section>

      <Section title="What Gets Tracked">
        <FeatureGrid
          items={[
            { title: 'Bureau Reports', body: 'Each report records the bureau, score value, report date, and status — reported or pending.' },
            { title: 'Platform Eligibility Score', body: 'Your credit history determines your eligibility across the Bankably platform.' },
            { title: 'Real-Time Utilization', body: 'Current balance, credit limit, and utilization are tracked live as you use your line.' },
            { title: 'Lifecycle Tracking', body: 'Status moves from Active through collections (if you default) to closed — fully transparent.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
